// extracted by mini-css-extract-plugin
export default {"wrap":"WorkSharing_wrap__c1yKi","line":"WorkSharing_line__jFF4v","text":"WorkSharing_text__PsmoM","textWrap":"WorkSharing_textWrap__HNgdb","label":"WorkSharing_label__6d+jI"};